<template>
    <div class="iniciative-section">
        <div class="container">
            <div class="title">
                <h2>
                    Encontre com facilidade a iniciativa que você está buscando
                </h2>
            </div>

            <div class="graphs-buttons">
                <button
                    :class="`btn btn-outline-${getIsDarkTheme ? 'light' : 'dark'} ${activeOption == 1 ? 'active' : ''}`"
                    @click=";(activeOption = 1), changeProfileChart(getCharts, 'potencias')"
                >
                    Potências
                </button>
                <button
                    :class="`btn btn-outline-${getIsDarkTheme ? 'light' : 'dark'} ${activeOption == 2 ? 'active' : ''}`"
                    @click=";(activeOption = 2), changeProfileChart(getCharts, 'investidores')"
                >
                    Investidores
                </button>
                <button
                    :class="`btn btn-outline-${getIsDarkTheme ? 'light' : 'dark'} ${activeOption == 3 ? 'active' : ''}`"
                    @click=";(activeOption = 3), changeProfileChart(getCharts, 'prestadores_servico')"
                >
                    Prestador de Serviço
                </button>
            </div>

            <div class="row graphs" v-if="getCharts">
                <div class="col-12 col-md-6" v-if="getLegalFormatChartData.datasets.length">
                    <BarChart
                        :title="'FORMATO JURÍDICO'"
                        :labels="getLegalFormatChartData.labels"
                        :datasets="getLegalFormatChartData.datasets"
                    />
                </div>

                <div class="col-12 col-md-6" v-if="initiativeNatureChartData.datasets.length">
                    <BarChart
                        :title="'NATUREZA DA INICIATIVA'"
                        :labels="initiativeNatureChartData.labels"
                        :datasets="initiativeNatureChartData.datasets"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from '@/ui/chart/Chart'
import BarChart from '@/ui/chart/BarChart'

export default {
    name: 'IniciativeSection',
    components: { Chart, BarChart },
    props: {
        charts: {
            default: null
        }
    },
    data() {
        return {
            activeOption: 1,
            legalFormatChartData: {
                labels: [],
                datasets: []
            },
            initiativeNatureChartData: {
                labels: [],
                datasets: []
            }
        }
    },
    watch: {
        charts(data) {
            this.charts = data
            this.changeProfileChart(data, 'potencias')
        }
    },
    methods: {
        changeProfileChart(data, profile) {
            this.legalFormatChartData = {
                labels: Object.keys(data[profile]).length
                    ? data[profile].formato_juridico.map(item => Object.keys(item)[0])
                    : [],
                datasets: Object.keys(data[profile]).length
                    ? data[profile].formato_juridico.map(item => Object.values(item)[0])
                    : []
            }

            this.initiativeNatureChartData = {
                labels: Object.keys(data[profile]).length
                    ? data[profile].natureza_iniciativa.map(item => Object.keys(item)[0])
                    : [],
                datasets: Object.keys(data[profile]).length
                    ? data[profile].natureza_iniciativa.map(item => Object.values(item)[0])
                    : []
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getCharts() {
            return this.charts
        },
        getLegalFormatChartData() {
            return this.legalFormatChartData
        },
        getInitiativeNatureChartData() {
            return this.initiativeNatureChartData
        }
    }
}
</script>

<style scope src="./IniciativeSection-light-theme.css"></style>
<style scope src="./IniciativeSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/iniciative-section/IniciativeSection.vue